import { cloneDeep, head, sortBy } from 'lodash'
import moment from '@/utils/moment'
import { BRAND_CODE } from '@/utils/brand-detector'

export const ENTRY_METHODS = {
  FREE: 'free',
  PAYPAL: 'paypal',
  MOBILE: 'mobile',
  CARD: 'card',
  APPLE: 'apple',
  GOOGLE: 'google'
}

export const QUESTION_TYPES = {
  IMAGE: 'image',
  AUDIO: 'audio'
}

export const ANSWER_TYPES = {
  SELECT: 'select',
  TEXT: 'text'
}

export const ENTRY_STATUS = {
  SUCCESS: 'success',
  PENDING: 'pending',
  PENDING_PAYMENT: 'pending-payment',
  FAIL: 'fail',
  FAIL_INIT: 'fail-init',
  CAPPING_EXCEEDED: 'capping-exceeded'
}

export default class Competition {
  // Must be public for Vue reactivity to work, but don't use outside of model
  _data

  constructor (params) {
    this._data = cloneDeep(params)
  }

  get id () {
    return this._data.id
  }

  get title () {
    return this._data.title
  }

  get slug () {
    return this._data.slug
  }

  get brands () {
    return this._data.brands
  }

  get priceOptions () {
    return this._data.priceOptions
  }

  get lowestPriceOptions () {
    return head(sortBy(this._data.priceOptions, ['cost']))
  }

  get questions () {
    return this._data.questions
  }

  get dateStart () {
    return this._data.dateStart
  }

  get dateStop () {
    return this._data.dateStop
  }

  get meta () {
    return this._data.meta
  }

  get imageCard () {
    return this._data.brandsMeta[BRAND_CODE].imageCard
  }

  get heroImageMobile () {
    return this._data.brandsMeta[BRAND_CODE].heroImageMobile
  }

  get heroImage () {
    return this._data.brandsMeta[BRAND_CODE].heroImage
  }

  get heroTitle () {
    return this._data.brandsMeta[BRAND_CODE].heroTitle
  }

  get cardLabel () {
    return this._data.brandsMeta[BRAND_CODE].cardLabel
  }

  get heroContent () {
    return this._data.brandsMeta[BRAND_CODE].heroContent
  }

  get optIn () {
    const { optInLabel, optInSMS, optInLinkTerms, optInLinkPrivacy } = this._data.brandsMeta[BRAND_CODE]
    return {
      optInLabel,
      optInSMS,
      optInLinkTerms,
      optInLinkPrivacy
    }
  }

  get competitionLink () {
    return { name: 'competition', params: { competitionId: this.id, competitionSlug: this.slug } }
  }

  isFree () {
    return this._data.entryMethods.includes(ENTRY_METHODS.FREE)
  }

  isPaid () {
    return [ENTRY_METHODS.PAYPAL, ENTRY_METHODS.MOBILE, ENTRY_METHODS.CARD].some(m => this._data.entryMethods.includes(m))
  }

  isPayPal () {
    return this._data.entryMethods.includes(ENTRY_METHODS.PAYPAL)
  }

  isMobile () {
    return this._data.entryMethods.includes(ENTRY_METHODS.MOBILE)
  }

  isCard () {
    return this._data.entryMethods.includes(ENTRY_METHODS.CARD)
  }

  isApple () {
    return this._data.entryMethods.includes(ENTRY_METHODS.APPLE)
  }

  isGoogle () {
    return this._data.entryMethods.includes(ENTRY_METHODS.GOOGLE)
  }

  isOpen () {
    return moment().isBetween(this.dateStart, this.dateStop, undefined, '[]')
  }

  isClosed () {
    return moment().isAfter(this.dateStop)
  }
}
